import { cn } from '@/lib/utils';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  /** Optional section title */
  title?: string;
  /** Optional subtitle/description */
  subtitle?: string;
}

/**
 * Consistent section wrapper with optional title and spacing.
 */
export function Section({ children, className, title, subtitle }: SectionProps) {
  return (
    <section className={cn('mt-6 sm:mt-8', className)}>
      {(title || subtitle) && (
        <div className="mb-4 space-y-1">
          {title && (
            <h2 className="text-sm font-medium text-foreground">{title}</h2>
          )}
          {subtitle && (
            <p className="text-xs text-muted-foreground">{subtitle}</p>
          )}
        </div>
      )}
      {children}
    </section>
  );
}
